var _path, _path2, _circle, _circle2, _rect, _rect2, _rect3, _rect4, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgConfettiLeft(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 326,
    height: 456,
    viewBox: "0 0 326 456",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.7099 161.049L87.841 208.71L67.701 215.812L59.7099 161.049Z",
    fill: "#EAD300"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.44977 325.593L51.5218 321.514L50.2082 338.208L7.44977 325.593Z",
    fill: "#EA0000"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 183.284,
    cy: 303.454,
    r: 4.62367,
    fill: "#9F00EA"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 189.449,
    cy: 444.678,
    r: 10.7886,
    fill: "#EAA900"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 89.2695,
    y: 379.5,
    width: 30.8245,
    height: 15.4122,
    transform: "rotate(-45.5869 89.2695 379.5)",
    fill: "#EAA900"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 286.293,
    y: 215.679,
    width: 9.24734,
    height: 15.4122,
    transform: "rotate(21.9912 286.293 215.679)",
    fill: "#EA0000"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 176.896,
    y: 180.404,
    width: 36.9894,
    height: 12.3298,
    transform: "rotate(-116.768 176.896 180.404)",
    fill: "#EA0000"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 275.535,
    y: 133.069,
    width: 36.9894,
    height: 12.3298,
    transform: "rotate(-116.768 275.535 133.069)",
    fill: "#EA0000"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M116.348 239.741C116.348 239.741 136.058 229.924 140.529 235.07C142.985 237.897 144.84 241.321 142.64 244.102C140.945 246.247 138.496 246.52 135.627 246.016C129.552 244.949 129.644 236.513 132.083 231.288C135.45 224.074 153.323 228.332 153.323 228.332",
    stroke: "#05EA00",
    strokeWidth: 3.69894
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M287.693 363.187C287.693 363.187 307.403 353.37 311.875 358.516C314.331 361.343 316.186 364.766 313.986 367.548C312.29 369.692 309.842 369.966 306.973 369.462C300.898 368.395 300.99 359.959 303.429 354.734C306.796 347.52 324.669 351.778 324.669 351.778",
    stroke: "#05EA00",
    strokeWidth: 3.69894
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M78.7335 304.528C78.7335 304.528 77.233 295.614 81.5393 293.837C85.1571 292.345 88.2935 298.946 91.2661 296.553C94.2771 294.129 86.7606 290.289 89.2085 287.389C91.7848 284.338 100.058 287.389 100.058 287.389",
    stroke: "#005EEA",
    strokeWidth: 3.69894
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M48.1312 117.409C48.1312 125.069 60.41 131.28 51.8656 131.28C43.3212 131.28 36.3945 125.069 36.3945 117.409C36.3945 109.748 43.3212 103.538 51.8656 103.538C60.41 103.538 48.1312 109.748 48.1312 117.409Z",
    fill: "#9F00EA"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M285.569 14.2641C285.569 21.9248 297.847 28.1351 289.303 28.1351C280.759 28.1351 273.832 21.9248 273.832 14.2641C273.832 6.60333 280.759 0.393066 289.303 0.393066C297.847 0.393066 285.569 6.60333 285.569 14.2641Z",
    fill: "#9F00EA"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M296.529 301.125C301.611 301.637 306.55 293.907 305.98 299.574C305.409 305.242 300.827 309.422 295.746 308.91C290.664 308.399 287.007 303.39 287.578 297.722C288.148 292.055 291.448 300.614 296.529 301.125Z",
    fill: "#005EEA"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M207.463 344.249L210.923 354.899H222.121L213.062 361.48L216.522 372.13L207.463 365.548L198.404 372.13L201.864 361.48L192.805 354.899H204.003L207.463 344.249Z",
    fill: "#05EA00"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M216.71 230.112L218.786 236.502H225.505L220.07 240.451L222.146 246.841L216.71 242.892L211.275 246.841L213.351 240.451L207.915 236.502H214.634L216.71 230.112Z",
    fill: "#EAD300"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M221.437 96.4942L222.972 83.2543L233.673 90.0384L234.893 78.9316L244.654 85.6556L247.694 73.6482",
    stroke: "#005EEA",
    strokeWidth: 3.08245
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgConfettiLeft);
export default __webpack_public_path__ + "static/media/confettiLeft.6ca6857d.svg";
export { ForwardRef as ReactComponent };